import bytes from 'bytes';
import { FileWithPreview } from './types';
import clsx from 'clsx';
import { KTSVG } from '../../../../_metronic/helpers';

interface Props {
  file: FileWithPreview;
  onRemove: () => void;
  className?: React.HTMLAttributes<HTMLDivElement>['className'];
}

export default function VideoPreview({ file, onRemove, className }: Props) {
  return (
    <div
      key={file.name}
      className={clsx('position-relative', className)}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <video controls src={file.preview} style={{ width: '100%', maxHeight: '500px' }} />
      <div
        className='btn btn-icon btn-sm btn-dark bg-dark bg-opacity-75 position-absolute start-100 translate-middle fs-9'
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
      >
        <KTSVG className='svg-icon-2' path='/media/icons/duotune/arrows/arr061.svg' />
      </div>
    </div>
  );
}
